export default __webpack_public_path__ + "static/media/admin-login.bdeb0f4c.jpg";